export const useHandlers = (params, isMore, fetcher) => {
    const onPageChange = (data) => {
        isMore.value = data.type === 'load-more'
        params.value.page = data.page
        console.log(data.page);
        
        fetcher()
    }

    const onUpdateParams = data => {
        params.value = { ...params.value, ...data }
    }

    const onFilterChange = (data) => {
        params.value = { ...params.value, ...data }
        fetcher(params.value)
    }

    return { onPageChange, onUpdateParams, onFilterChange }
}
